import { useCallback, useState } from 'react';
import {
  createDemoOrderInformation,
  DemoCartCheckoutItem,
  DemoCheckoutNavigationPayload,
  DemoHydratedOrder,
} from '../../models/demo/orders';

interface CreateOrderInput {
  cartItems: DemoCartCheckoutItem[];
  customerName?: string;
  customerEmail?: string;
  customerPhone?: string;
  businessName?: string;
  ownerId?: string;
  employeeId?: string;
  locationId?: string;
  paymentMethod?: 'Cash' | 'Mpesa';
}

interface CreateOrderResult {
  order: DemoHydratedOrder;
  checkoutPayload: DemoCheckoutNavigationPayload;
}

interface UseDemoCheckoutResult {
  isCreatingOrder: boolean;
  error: string | null;
  createOrder: (input: CreateOrderInput) => Promise<CreateOrderResult | null>;
}

export function useDemoCheckout(): UseDemoCheckoutResult {
  const [isCreatingOrder, setIsCreatingOrder] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createOrder = useCallback(
    async (input: CreateOrderInput): Promise<CreateOrderResult | null> => {
      setIsCreatingOrder(true);
      setError(null);
      try {
        const result = await createDemoOrderInformation(input);
        return result;
      } catch (err) {
        const message =
          err instanceof Error ? err.message : 'Failed to create demo order';
        setError(message);
        console.error('[useDemoCheckout] createOrder Error:', err);
        return null;
      } finally {
        setIsCreatingOrder(false);
      }
    },
    [],
  );

  return {
    isCreatingOrder,
    error,
    createOrder,
  };
}
